document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-buy-now-button]');
  if (!button || button.disabled) return;

  const formId = button.getAttribute('data-buy-now-form');
  const form = formId ? document.getElementById(formId) : button.closest('form');
  if (!form) return;

  const idInput = form.querySelector('input[name="id"]:not([disabled])');
  const variantId = idInput ? idInput.value : null;
  if (!variantId) return;

  const quantityInput = document.querySelector('input[name="quantity"][form="' + formId + '"]') || form.querySelector('input[name="quantity"]');
  const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

  button.disabled = true;
  button.classList.add('is-loading');

  fetch(window.themeVariables.routes.cartAddUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      // A/B test (assets/cyan-ab.js): tag the cart with the variant before leaving for checkout.
      var stamped = window.CYAN_AB && window.CYAN_AB.stamp ? window.CYAN_AB.stamp(true) : null;
      return Promise.resolve(stamped)
        .catch(function () {})
        .then(function () {
          window.location.href = Shopify.routes.root + 'checkout';
        });
    })
    .catch(function () {
      button.disabled = false;
      button.classList.remove('is-loading');
    });
});
